import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=10bc9216&scoped=true"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc9216",
  null
  
)

export default component.exports